import {useLocation} from 'react-router-dom';
import { useEffect, useState } from 'react';
import {PersonalInfoPopup} from '../../../components/PersonalInfoPopup';
import {TermsPopup} from '../../../components/TermsPopup';
import {Checkbox} from '../../../components/Checkbox';
import {VerificationBtn} from '../../../components/VerificationBtn';
import {AgreementType, VerityType} from '../../../types/types';

const VerificationSignUp = () => {
    const [psOpen, setPsOpen] = useState(false);
    const [termsOpen, setTermsOpen] = useState(false);
    const [agreements, setAgreements] = useState<AgreementType[]>([]);
    const [isClicked, setIsClicked] = useState<Boolean>(false);
    const { pathname } = useLocation();

    useEffect(() => {
        if(!isClicked) return;
        if(agreements.indexOf(AgreementType.SMS) > -1 && agreements.indexOf(AgreementType.MAILING) > -1){
            localStorage.setItem('agreementMarketing', '1')
        }else{
            localStorage.setItem('agreementMarketing', '0')
        }
    },[agreements])

    const handleAllCheck = (check: boolean) => {
        setIsClicked(true)
        setAgreements(check ? [
            AgreementType.AGE,
            AgreementType.SERVICE,
            AgreementType.PRIVACY,
            AgreementType.SMS,
            AgreementType.MAILING,
        ] : [])
    };

    const handleCheck = (items: AgreementType[]) => {
        setIsClicked(true)
        let results = [...agreements];
        items.forEach(
            item => {
                const idx = results.indexOf(item);
                if (idx === -1) {
                    results.push(item);
                } else {
                    results.splice(idx, 1);
                }
            })
        setAgreements(results);
    };

    return (
        <>
            <PersonalInfoPopup
                open={psOpen}
                onClose={() => setPsOpen(false)}
            />
            <TermsPopup
                open={termsOpen}
                onClose={() => setTermsOpen(false)}
            />
            <div className={`space-y-4`}>
                <h4 className={`text-14`}>주식회사 웍스아웃 통합회원 가입 안내</h4>
                <p className={`text-12 leading-5`}>
                    (주)웍스아웃의 통합회원 가입을 환영합니다.<br/>
                    회원으로 가입하시면 (주)웍스아웃에서 운영하는 브랜드의<br/>
                    온&오프라인 스토어의 회원 혜택을 하나의 계정으로 이용하실 수 있습니다.
                </p>
                <div className={`text-12 space-y-3`}>
                    <p className={`leading-5`}>
                        <h4 className={`text-14 mb-2`}>온라인 스토어</h4>
                        웍스아웃 온라인 스토어:&nbsp;
                        <a href="https://www.worksout.co.kr"
                           target="_blank"
                           rel="noopener noreferrer">
                            www.worksout.co.kr
                        </a>
                        <br/>
                        칼하트윕 온라인 스토어:&nbsp;
                        <a href="https://www.carhartt-wip.co.kr/"
                           target="_blank"
                           rel="noopener noreferrer">
                            www.carhatt-wip.co.kr
                        </a>
                        <br/>
                        데우스 엑스 마키나 온라인 스토어:&nbsp;
                        <a href="https://www.deuscustoms.co.kr"
                           target="_blank"
                           rel="noopener noreferrer">
                            www.deuscustoms.co.kr
                        </a>
                    </p>
                    <p className={`leading-5`}>
                        <h4 className={`text-14 mb-2`}>오프라인 스토어</h4>
                        웍스아웃 오프라인 스토어, 칼하트윕 오프라인 스토어<br/>데우스 엑스 마키나 오프라인 스토어, 오베이 오프라인 스토어<br/>반스 바이 웍스아웃 오프라인 스토어
                    </p>
                </div>
                <div className={`space-y-3`}>
                    <p className={`text-13 leading-5`}>
                        <span className={`font-bold`}>주식회사 웍스아웃 통합회원 가입</span>을 위해<br/>
                        아래 약관에 동의해주세요.
                    </p>
                    <div className={`space-y-2`}>
                        <div className={`border-b pb-3 mb-3 border-gray-300`}>
                            <Checkbox
                                label="약관 전체 동의"
                                onChange={e => handleAllCheck(e.target.checked)}
                                checked={agreements.length === 5}
                            />
                        </div>
                        <Checkbox
                            label={`만 14세 이상 가입 동의 <span class="tx_3e52bb">(필수)</span>`}
                            onChange={_ => handleCheck([AgreementType.AGE])}
                            checked={agreements.indexOf(AgreementType.AGE) > -1}
                        />
                        <div className={`flex justify-between`}>
                            <Checkbox
                                label={`이용약관 동의 <span class="tx_3e52bb">(필수)</span>`}
                                onChange={_ => handleCheck([AgreementType.SERVICE])}
                                checked={agreements.indexOf(AgreementType.SERVICE) > -1}
                            />
                            <button
                                onClick={() => setTermsOpen(true)}
                                className={`text-12 underline text-gray-500`}>약관보기
                            </button>
                        </div>
                        <div className={`flex justify-between`}>
                            <Checkbox
                                label={`개인정보 수집 · 이용 동의 <span class="tx_3e52bb">(필수)</span>`}
                                onChange={_ => handleCheck([AgreementType.PRIVACY])}
                                checked={agreements.indexOf(AgreementType.PRIVACY) > -1}
                            />
                            <button
                                onClick={() => setPsOpen(true)}
                                className={`text-12 underline text-gray-500`}>약관보기
                            </button>
                        </div>
                        <Checkbox
                            label="마케팅 정보 수신 동의 (선택)"
                            checked={agreements.indexOf(AgreementType.SMS) > -1 && agreements.indexOf(AgreementType.MAILING) > -1}
                            onChange={_ => handleCheck([AgreementType.SMS, AgreementType.MAILING])}
                        />
                    </div>
                    <VerificationBtn
                        returnUrl={pathname}
                        buttonText={"휴대폰 본인인증"}
                        verifyType={VerityType.SIGNUP}
                        checkboxChecked={
                            agreements.indexOf(AgreementType.SERVICE) === -1 || agreements.indexOf(AgreementType.PRIVACY) === -1 || agreements.indexOf(AgreementType.AGE) === -1
                        }
                    />
                </div>
            </div>
        </>
    );
};

export default VerificationSignUp;
